import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { NonMedicalMasterSchema } from "./type";
import { ListNonMedicalMasterResponse } from "@/gen/non_medical_master/list_non_medical_master_pb";
import { pharmacyClient } from "@/connect";

export const getNonMedicalMasterItems = async (page: number, pageSize: number, search: string): Promise<ListNonMedicalMasterResponse> => {
    return await pharmacyClient.listNonMedicalMaster({
        page,
        pageSize,
        search: search,
    });
};